import expandableContent from '../expandable-content';
import lockedContent from '../locked-content';
import getLoginRedirectionLink from '../locked-content/services/getLoginRedirectionLink';

const parse = (
  domContainer: HTMLElement,
  sandboxLink: HTMLAnchorElement,
  shouldLockSandbox: boolean
) => {
  const a11yId = 'code-sandbox';
  const iframeWrapper = document.createElement('div');
  const iframe = document.createElement('iframe');
  iframe.id = a11yId;

  iframeWrapper.classList.add('oc-code-sandbox');
  iframe.classList.add('oc-code-sandbox__iframe');

  iframe.src = sandboxLink.href;
  iframeWrapper.appendChild(iframe);

  sandboxLink.parentNode?.insertBefore(iframeWrapper, sandboxLink);

  if (shouldLockSandbox) {
    lockedContent.lock.init(iframeWrapper, sandboxLink, getLoginRedirectionLink());
  } else {
    (iframeWrapper.style as any).position = 'relative';
  }

  expandableContent.expand.init(domContainer, iframeWrapper, a11yId);
  sandboxLink.parentNode?.removeChild(sandboxLink);
};

const init = (domContainer: HTMLElement, shouldLockSandbox: boolean) => {
  const codeSandboxLinks = Array.from(
    domContainer.querySelectorAll('[href*="next.tech"]')
  ) as HTMLAnchorElement[];
  codeSandboxLinks.forEach((sandboxLink) => parse(domContainer, sandboxLink, shouldLockSandbox));
};

export default { parse, init };
